<template>
  <div class="antialiased bg-body text-body font-body">
    <Navbar :navRoutes="routeElements" />
    <div class="p-20">
      <ais-instant-search
        :search-client="searchClient"
        :routing="routing"
        index-name="place"
      >
        <section>
          <div class="container px-4 mx-auto">
            <div class="flex flex-wrap items-center -mx-3">
              <div class="w-full lg:w-1/2 px-3">
                <div class="py-12">
                  <div
                    class="max-w-lg lg:max-w-md mx-auto lg:mx-0 mb-8 text-center lg:text-left"
                  >
                    <h1
                      class="text-3xl md:text-4xl mb-4 font-bold font-heading"
                    >
                      <span class="text-purple-600">{{ h2Text.text }}</span>
                    </h1>
                    <!-- <p class="text-purpleGray-400 leading-relaxed">About Text</p> -->

                    <ais-search-box />
                    <br />
                    <ais-refinement-list
                      attribute="address_parts"
                      :searchable="true"
                      searchable-placeholder="Filter by location"
                      :limit="4"
                    />

                    <ais-clear-refinements />
                    <ais-configure :hitsPerPage="8" />
                  </div>
                </div>
              </div>
              <div class="w-full lg:w-1/2 px-3">
                <div class="flex flex-wrap max-w-7xl mx-auto mb-6">
                  <div class="p-4 bg-white shadow rounded">
                    <h3 class="mb-2 text-xl font-semibold font-heading">
                      Facilities
                    </h3>
                    <ais-refinement-list
                      attribute="facilities"
                      operator="and"
                    />
                  </div>
                  <div class="p-4 bg-white shadow rounded">
                    <h3 class="mb-2 text-xl font-semibold font-heading">
                      Care
                    </h3>
                    <ais-refinement-list
                      attribute="care"
                      operator="and"
                      show-more
                    />
                  </div>
                  <div class="p-4 bg-white shadow rounded">
                    <h3 class="mb-2 text-xl font-semibold font-heading">
                      Safety
                    </h3>
                    <ais-refinement-list
                      attribute="safety"
                      operator="and"
                      show-more
                    />
                  </div>
                </div>
                <div
                  class="socializer a sr-32px sr-opacity sr-icon-white sr-pad"
                >
                  <span class="sr-facebook"
                    ><a
                      :href="
                        'https://www.facebook.com/share.php?u=' +
                        location.href +
                        '&amp;'
                      "
                      target="_blank"
                      title="Facebook"
                      ><i class="fab fa-facebook-f"></i></a
                  ></span>
                  <span class="sr-twitter"
                    ><a
                      :href="
                        'https://twitter.com/intent/tweet?text=Check out%20-%20' +
                        location.href +
                        '%20'
                      "
                      target="_blank"
                      title="Twitter"
                      ><i class="fab fa-twitter"></i></a
                  ></span>
                  <span class="sr-whatsapp"
                    ><a
                      :href="
                        'https://api.whatsapp.com/send?text=%20' + location.href
                      "
                      target="_blank"
                      title="WhatsApp"
                      ><i class="fab fa-whatsapp"></i></a
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="hidden navbar-menu fixed top-0 left-0 bottom-0 w-5/6 max-w-sm z-50"
          >
            <div
              class="navbar-backdrop fixed inset-0 bg-purpleGray-800 opacity-25"
            ></div>
            <nav
              class="relative flex flex-col py-6 px-6 w-full h-full bg-white border-r overflow-y-auto"
            >
              <div class="flex items-center mb-8">
                <a class="mr-auto text-3xl font-semibold leading-none" href="#">
                  <img
                    class="h-40"
                    src="/metis-assets/logos/metis/metis.webp"
                    alt="localgps Logo"
                  />
                </a>
                <button class="navbar-close">
                  <svg
                    class="h-6 w-6 text-purpleGray-400 cursor-pointer hover:text-purpleGray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewbox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>
              <ul>
                <li class="mb-1">
                  <a
                    class="block p-4 text-sm text-purpleGray-500 hover:bg-purple-50 hover:text-purple-600"
                    href="#"
                    >Home</a
                  >
                </li>
              </ul>
              <div class="mt-4 pt-6 border-t border-purpleGray-100">
                <a
                  class="block px-4 py-3 mb-3 text-xs text-center font-semibold leading-none bg-purple-600 hover:bg-purple-700 text-white rounded"
                  href="javascript:getQuote()"
                  >Get a Quote</a
                >
              </div>
            </nav>
          </div>
        </section>
        <section class="py-5 xl:bg-contain bg-top bg-no-repeat">
          <ais-hits>
            <template v-slot="{ items }">
              <div class="container px-4 mx-auto">
                <div class="flex flex-wrap -mx-3 mb-12">
                  <div class="flex flex-wrap max-w-7xl mx-auto mb-6">
                    <div
                      class="w-full md:w-1/2 px-3 mb-6"
                      v-for="(item, index) in items"
                      :key="index"
                    >
                      <a :href="item.path" :alt="item.title">
                        <div class="p-8 bg-white shadow rounded">
                          <div class="flex items-center mb-4">
                            <div class="pl-4">
                              <h3
                                class="mb-2 text-xl font-semibold font-heading"
                              >
                                {{ item.title }}
                              </h3>

                              <ais-highlight
                                attribute="address"
                                class="text-black"
                                :hit="item"
                              ></ais-highlight>
                            </div>
                          </div>
                          <ais-highlight
                            attribute="descriptionSnip"
                            class="leading-loose text-purpleGray-400"
                            :hit="item"
                          ></ais-highlight>
                        </div>
                      </a>
                    </div>
                  </div>
                  <ais-pagination />
                </div>
              </div>
            </template>
          </ais-hits>
        </section>
      </ais-instant-search>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.ais-Hits-list {
}

.ais-InstantSearch {
}

.ais-Hits-item img {
}
.hit-name {
}
.hit-description {
}
</style>

<script>
import { history as historyRouter } from "instantsearch.js/es/lib/routers";

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

import Navbar from "../../../components/Navbar.vue";
import Footer from "../../../components/Footer.vue";

import "../static/main.css";

import "../../../css/fa.css";
import "../../../css/socailizer.css";

import "instantsearch.css/themes/satellite-min.css";

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: "Hu52dwsas2AdxdE",
    nodes: [
      {
        host: "typesense.localgps.co.uk",
        port: "443",
        protocol: "https",
      },
    ],
    cacheSearchResultsForSeconds: 10 * 60,
  },
  // The following parameters are directly passed to Typesense's search API endpoint.
  //  So you can pass any parameters supported by the search endpoint below.
  //  query_by is required.
  additionalSearchParameters: {
    query_by: "title,description,address,cqc_rating,facilities,care,safety",
  },
});

const searchClient = typesenseInstantsearchAdapter.searchClient;

let h2Text = {
  text: "Search for gps",
};

// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getCategorySlug(name) {
  return name[0].split(" ").map(encodeURIComponent).join("+");
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
  return slug.split("+").map(decodeURIComponent).join(" ");
}

const routing = {
  router: historyRouter({
    windowTitle(routeState) {
      const queryTitle = "localgps Find Care";

      if (routeState.address_parts.length > 0) {
        h2Text.text = "Care in " + routeState.address_parts;

        return `${routeState.address_parts} – ${queryTitle}`;
      }

      return queryTitle;
    },

    createURL({ qsModule, routeState, location }) {
      const urlParts = location.href.match(/^(.*?)\//);
      const baseUrl = `${urlParts ? urlParts[1] : ""}/`;

      const address_partsPaths = routeState.address_parts
        ? `${getCategorySlug(routeState.address_parts)}/`
        : "";
      const queryParameters = {};

      if (routeState.query) {
        queryParameters.query = encodeURIComponent(routeState.query);
      }
      if (routeState.facilities) {
        queryParameters.facilities =
          routeState.facilities.map(encodeURIComponent);
      }
      if (routeState.care) {
        queryParameters.care = routeState.care.map(encodeURIComponent);
      }
      if (routeState.safety) {
        queryParameters.safety = routeState.safety.map(encodeURIComponent);
      }

      const queryString = qsModule.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: "repeat",
      });

      return `${baseUrl}${address_partsPaths}${queryString}`;
    },

    parseURL({ qsModule, location }) {
      const pathnameMatches = location.pathname.match(/\/(.*?)\/?$/);
      let address_parts = getCategoryName(
        (pathnameMatches && pathnameMatches[1]) || ""
      );

      if (address_parts === "search") address_parts = "";

      const {
        query = "",
        facilities = [],
        safety = [],
        care = [],
      } = qsModule.parse(location.search.slice(1));
      // `qs` does not return an array when there's a single value.
      const allfacilities = Array.isArray(facilities)
        ? facilities
        : [facilities].filter(Boolean);
      const allcare = Array.isArray(care) ? care : [care].filter(Boolean);
      const allsafety = Array.isArray(safety)
        ? safety
        : [safety].filter(Boolean);

      return {
        query: decodeURIComponent(query),
        facilities: allfacilities.map(decodeURIComponent),
        safety: allsafety.map(decodeURIComponent),
        care: allcare.map(decodeURIComponent),
        address_parts: address_parts,
      };
    },
  }),

  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = uiState["place"] || {};

      const stateToRouteVal = {
        query: indexUiState.query,
        facilities:
          indexUiState.refinementList && indexUiState.refinementList.facilities,
        care: indexUiState.refinementList && indexUiState.refinementList.care,
        safety:
          indexUiState.refinementList && indexUiState.refinementList.safety,
        rooms: indexUiState.refinementList && indexUiState.refinementList.rooms,
        address_parts:
          indexUiState.refinementList &&
          indexUiState.refinementList.address_parts,
      };

      return stateToRouteVal;
    },

    routeToState(routeState) {
      const routeToStateVal = {
        place: {
          query: routeState.query,
          page: 1,
          refinementList: {
            facilities: routeState.facilities,
            care: routeState.care,
            safety: routeState.safety,
            address_parts: routeState.address_parts
              ? [routeState.address_parts]
              : routeState.address_parts,
          },
        },
      };

      return routeToStateVal;
    },
  },
};

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
  },

  beforeMount() {
    this.routeElements = [{ name: "Home", link: "/" }];

    this.payload = {};
    this.$route = {};

    this.searchClient = searchClient;

    this.routing = routing;

    this.location = location;
    this.h2Text = h2Text;
  },
};
</script>
